import { Injectable } from '@angular/core';
import { AuthenticatedHttpService } from './authenticatedhttp.service';
import { Observable, BehaviorSubject } from 'rxjs';

import { Contact } from '../model/crm/contact.model';
import { Prospect } from '../model/prospect';

@Injectable()
export class ProspectsService {
    private baseUrl;
    navigateBackToProductLine$: BehaviorSubject<boolean> = new BehaviorSubject(false);

    constructor(
        private _http: AuthenticatedHttpService
	) {
		this.baseUrl = _http.getBaseURLFromCookie();
    }

    getProsectsByRetailerNumber(retailerNumber: string): Observable<Array<Prospect>> {

        //let options = this.serviceUtils.getStandardHeaderOptions();
        return this._http.get(this.baseUrl + `/api/prospects/${retailerNumber}/retailer`)
            .map(x => {
                let prospects = (<Array<Prospect>>x.json());
                prospects.forEach((p) => {

                    Contact.normalize(p.Contact);
                });

                return prospects;
            })
            .catch(this._http.handleError);
    }

    getProspectById(retailerNumber: string, prospectId: number): Observable<Prospect> {
        return this._http.get(this.baseUrl + `/api/prospects/${retailerNumber}/retailer`)
            .map(x => {
                let prospects = (<Array<Prospect>>x.json());
                prospects.forEach((p) => {

                    Contact.normalize(p.Contact);
                });

                let prospect = prospects.find(p => p.ProspectId === prospectId);

                return prospect;
            })
            .catch(this._http.handleError);
    }

    searchProspects(searchString: string): Observable<Array<Prospect>> {
        return this._http.get(this.baseUrl + `/api/prospects/${searchString}/search`)
            .map(x => {
                let prospects = (<Array<Prospect>>x.json());
                prospects.forEach((p) => {

                    Contact.normalize(p.Contact);
                });

                return prospects;
            })
            .catch(this._http.handleError);
    }


}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/prospect.service.ts